<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_MEDECIN')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="medecinForm">
            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'MED'">
                <label for="medecin-numero" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_MEDECIN_NUMERO')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-numero" matInput type="text" name="numero" formControlName="numero" />
                    <mat-error
                        *ngIf="medecinForm.controls.numero.touched && medecinForm.controls.numero.hasError('required')">
                        {{texteService.getTexte('ERR_MEDECIN_REQUIRED')}}</mat-error>
                    <mat-error
                        *ngIf="medecinForm.controls.numero.touched && medecinForm.controls.numero.hasError('rppsUnvalid')">
                        {{texteService.getTexte('ERR_MEDECIN_NUMERO')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="medecin-nom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_NOM')}}<span class="red-label"
                        *ngIf="typesSelected.situation.code === 'MED'">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-nom" matInput type="text" name="nom" formControlName="nom" />
                    <mat-error *ngIf="medecinForm.controls.nom.touched 
                        && medecinForm.controls.nom.hasError('required') 
                        && typesSelected.situation.code === 'MED'">
                        {{texteService.getTexte('ERR_PATIENT_NOM_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class=" form-row d-flex align-self-center">
                <label for="medecin-prenom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PRENOM')}}<span
                        class="red-label" *ngIf="typesSelected.situation.code === 'MED'">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-prenom" matInput type="text" name="prenom" formControlName="prenom" />
                    <mat-error *ngIf="medecinForm.controls.prenom.touched 
                            && medecinForm.controls.prenom.hasError('required') 
                            && typesSelected.situation.code === 'MED'">
                        {{texteService.getTexte('ERR_PATIENT_PRENOM_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class=" form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <label for="medecin-etablissement"
                    class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_MEDECIN_ETABLISSEMENT')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-etablissement" matInput type="text" name="etablissement" formControlName="etablissement" />
                </mat-form-field>
            </div>

            <div class=" form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <label for="medecin-specialite" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_MEDECIN_SPEC')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-specialite" matInput type="text" name="specialite" formControlName="specialite" />
                </mat-form-field>
            </div>

            <div class=" form-row d-flex align-self-center">
                <label for="medecin-email" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_EMAIL')}}<span
                        class="red-label" *ngIf="typesSelected.situation.code === 'MED'">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="medecin-email" matInput type="email" name="email" formControlName="email" />
                    <mat-error *ngIf="medecinForm.controls.email.touched 
                                    && medecinForm.controls.email.hasError('required') 
                                    && typesSelected.situation.code === 'MED'">
                        {{texteService.getTexte('ERR_CONTACT_EMAIL_REQUIRED')}}</mat-error>
                    <mat-error
                        *ngIf="medecinForm.controls.email.touched && medecinForm.controls.email.hasError('email')">
                        {{texteService.getTexte('ERR_EMAIL_UNVALID')}}</mat-error>
                </mat-form-field>
            </div>

            <div class=" form-row d-flex align-self-center">
                <label for="medecin-telephone" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_MEDECIN_TEL')}}<span
                        class="red-label" *ngIf="typesSelected.situation.code === 'MED'">*</span></label>

                <div class="d-flex col-md-7">
                    <mat-form-field class="indictif-input" *ngIf="this.typesSelected.situation.code === 'INT'">
                        <span matPrefix>+</span>
                        <input matInput type="text" name="indicatif" formControlName="indicatif" [matAutocomplete]="indicatif" />
                        <mat-autocomplete #indicatif="matAutocomplete">
                            <mat-option *ngFor="let ind of indicatifs" [value]="ind">
                                {{ind}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="medecinForm.controls.indicatif.touched && medecinForm.controls.indicatif.hasError('indicatifUnvalid')">
                            {{texteService.getTexte('ERR_CHAMP_INVALID')}}</mat-error>
                    </mat-form-field>
                    <mat-form-field class="flex-grow-1">
                        <span matPrefix *ngIf="this.typesSelected.situation.code === 'INT'">|&nbsp;</span>
                        <input id="medecin-telephone" matInput type="tel" name="telephone" formControlName="telephone" />
                        <mat-error *ngIf="medecinForm.controls.telephone.touched 
                    && medecinForm.controls.telephone.hasError('required') 
                    && typesSelected.situation.code === 'MED'">
                            {{texteService.getTexte('ERR_MEDECIN_TEL')}}</mat-error>
                        <mat-error
                            *ngIf="medecinForm.controls.telephone.touched && medecinForm.controls.telephone.hasError('telUnvalid')">
                            {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
